import React from "react";
import { useNavigate } from "react-router-dom";
import confetti from "canvas-confetti";
import { toast } from "sonner";
import Shell from "../components/Shell";
import { PrimaryButton } from "../components/bits";
import { StageBackdrop } from "../components/winners/StageBackdrop";
import { WinnersHero } from "../components/winners/WinnersHero";
import { TrackPodium } from "../components/winners/TrackPodium";
import { SponsorWall } from "../components/winners/SponsorWall";
import { WrapUpGallery } from "../components/winners/WrapUpGallery";
import { TRACKS } from "../lib/winners";
import { endpoints } from "../lib/api";

const COLORS = ["#C9A646", "#E2C46A", "#38BDF8", "#7C5CFF", "#FFFFFF"];
const reduced = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

function celebrate() {
  if (reduced()) return;
  const fire = (x, angle) => confetti({ particleCount: 70, spread: 70, startVelocity: 55, angle, origin: { x, y: 0.7 }, colors: COLORS, scalar: 0.9 });
  fire(0.1, 60); fire(0.9, 120);
  setTimeout(() => confetti({ particleCount: 90, spread: 120, origin: { x: 0.5, y: 0.35 }, colors: COLORS, shapes: ["star"], scalar: 1.1 }), 250);
}

export default function WinnersPage() {
  const navigate = useNavigate();
  const [infos, setInfos] = React.useState({});

  React.useEffect(() => {
    document.title = "Winners · U-Hackathon 2026";
    const slugs = TRACKS.flatMap((t) => t.winners.map((w) => w.slug));
    Promise.all(slugs.map((s) => endpoints.project(s).catch(() => null))).then((rows) => {
      const map = {};
      rows.forEach((p) => { if (p) map[p.slug] = p; });
      setInfos(map);
    });
    const t = setTimeout(celebrate, 600);
    return () => clearTimeout(t);
  }, []);

  const share = async () => {
    const url = `${window.location.origin}/winners`;
    const text = "Meet the U-Hackathon 2026 winners 🏆";
    try {
      if (navigator.share) await navigator.share({ title: "U-Hackathon 2026 Winners", text, url });
      else { await navigator.clipboard.writeText(url); toast("Link copied. Spread the love!"); }
    } catch { /* share cancelled */ }
  };

  return (
    <Shell>
      <div className="relative isolate overflow-hidden bg-navy-950" data-testid="winners-page">
        <StageBackdrop />
        <WinnersHero onCelebrate={celebrate} onShare={share} />
        {TRACKS.map((t) => <TrackPodium key={t.key} track={t} infos={infos} />)}
        <WrapUpGallery />
        <SponsorWall />
        <section className="relative mx-auto w-full max-w-3xl px-4 pb-20 pt-6 text-center" data-testid="winners-closing">
          <h2 className="font-display text-[34px] font-extrabold leading-tight text-white sm:text-[44px]">
            Every project is worth a look.
          </h2>
          <p className="mx-auto mt-2 max-w-md text-on-dark-muted">The winners are just the start. 99 projects shipped in 24 hours, and each team could use your support.</p>
          <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <PrimaryButton onClick={() => navigate("/deck")} data-testid="winners-swipe-cta">Swipe all 99 projects</PrimaryButton>
            <button onClick={() => navigate("/explore")} data-testid="winners-browse-cta" className="font-semibold text-violet-300 hover:text-white">Browse the list</button>
          </div>
        </section>
      </div>
    </Shell>
  );
}
